import { useState, useEffect } from "react";
import {apiUpdateField} from "../api/private";
import {aboutAcf} from "../constants/acf";
const useEditField = (initValue) => {
    const [value, setValue] = useState('');
    const [loading, setLoading] = useState(false);


    useEffect(() => {
        setValue(initValue)
    }, [initValue])

    const updateField = async (value, key) => {
        setLoading(true);
        await apiUpdateField(value, key)
        setLoading(false);
    };


    return [value, setValue, updateField, loading]

}

export default useEditField;


// WEBPACK FOOTER //
// ./src/hooks/useEditField.js